<template>
  <el-container class="app-wrapper">
    <!-- 顶部导航 -->
    <el-header height="60px" class="app-header">
      <div class="header-left">
        <div class="logo" @click="_toIndex">{{ systemInfo.systemSimpleTitle }}</div>
        <el-menu mode="horizontal" :default-active="activeMenu" class="header-menu" background-color="#1e2132"
          text-color="#fff" active-text-color="#409EFF">
          <el-menu-item :index="item.caId" v-for="(item, index) in catalogs" :key="index"
            @click="_changeMenuCatalog(item, true)">{{ item.name }}</el-menu-item>
        </el-menu>
      </div>
      <div class="header-right">
        <el-dropdown @command="changeShop" v-if="storeInfo.storeTypeCd == '800900000005'" class="margin-right">
          <span class="user-info">
            {{ curShopName }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="c" v-for="(c, index) in shops" :key="index">{{ c.shopName }}</el-dropdown-item>
            <el-dropdown-item command="moreShop" class="moreShop">更多门店</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown @command="handleCommand">
          <span class="user-info">
            {{ username }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">{{ $t('common.logout') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span class="margin-left">{{ systemInfo.version }}</span>

      </div>
    </el-header>

    <el-container>
      <!-- 左侧菜单 width="64px"-->
      <el-aside class="app-aside" width="80">
        <div class="vc-menu flex justify-start" id="menu-nav">
          <div class="vc-menu-main">
            <ul>
              <template v-for="(menu, index) in menuTree">
                <li :key="index" v-if="menu.childs && menu.childs.length > 0" :class="{ active: menu.active }"
                  @click="switchMenu(menu)">
                  <i class="fa " v-bind:class="menu.icon"></i><span class="margin-left-xs">{{ menu.name }}</span>
                  <span class="menu-todo-badge" v-if="_todoBadgeOfParent(menu) > 0">{{ _todoBadgeOfParent(menu) > 99 ? '99+' : _todoBadgeOfParent(menu) }}</span>
                </li>
              </template>
            </ul>
          </div>
          <div class="vc-menu-sub" v-if="subMenus && subMenus.length > 0">
            <ul>
              <li class="title">{{ curMenuName }}</li>
              <template v-for="(subMenu, index) in subMenus">
                <li :key="index" v-if="subMenu.isShow == 'Y'" :class="{ active: subMenu.active }"
                  v-on:click="_gotoPage(subMenu.href, subMenu.name)">
                  {{ subMenu.name }}
                  <span class="todo-badge" v-if="_todoBadgeOf(subMenu) > 0">{{ _todoBadgeOf(subMenu) > 99 ? '99+' : _todoBadgeOf(subMenu) }}</span>
                </li>
              </template>
              <li class="sub-footer" @click="_closeSubMenu()"><i class="fa fa-dedent"></i></li>
            </ul>
          </div>
        </div>
      </el-aside>

      <!-- 主要内容区 -->
      <el-main class="app-main ">
        <div class="tabs-wrap" v-if="visitedTabs.length > 0">
          <div class="tabs-list">
            <div
              v-for="tab in visitedTabs"
              :key="tab.path"
              :class="['tabs-item', { active: $route.path === tab.path }]"
              @click="goTab(tab)"
            >
              <span class="tabs-item-title">
                {{ tab.titleKey ? $t(tab.titleKey) : tab.title }}
              </span>
              <i
                class="el-icon-close tabs-item-close"
                @click.stop="removeTab(tab)"
                v-if="visitedTabs.length > 1"
              />
            </div>
          </div>
          <el-button
            type="text"
            size="mini"
            class="tabs-close-all"
            @click="closeAllTabs"
          >
            全部关闭
          </el-button>
        </div>

        <router-view />
      </el-main>
    </el-container>
    <more-shop ref="moreShop" />
    <!-- <view-menu-user-list ref="viewMenuUserModel" />
      <search-community-data-list ref="searchCommunityDataModel" /> -->
    <view-multiple-qrcode ref="viewMultipleQrcode" />
  </el-container>
</template>

<script>
import { _getMenuCatalog, getMenuTree, jumpToMall, jumpToIot } from '@/api/user/menuApi'
import { getStoreInfo, getUserInfo } from "@/api/user/indexApi"
import { getShopId } from '@/api/shop/shopApi'

import { listSystemInfo } from '@/api/system/systemInfoManageApi'
import { deepCopy, setCurrentShop } from "@/utils/vc"
import { getShopName } from '@/api/shop/shopApi'
import { listMyEnteredShops } from '@/api/frame/wuyeRegisterApi'
import moreShop from '@/components/shop/moreShop.vue'
//   import viewMenuUserList from '@/components/system/viewMenuUserList.vue'
//   import searchCommunityDataList from '@/components/system/searchCommunityDataList.vue'
import { initSystem } from '@/api/util/vcApi'
import config from '@/conf/config'
import viewMultipleQrcode from '@/components/system/viewMultipleQrcode.vue'
import { getCurrentShop } from "@/utils/vc"
import request from '@/utils/request'


export default {
  name: 'Layout',
  data() {
    return {
      catalogs: [],
      menuTree: [],
      subMenus: [],
      // 商家申请待办角标计数（上架商品=待审核商品数，导入管理=含待审商品的批次数，
      // 开店审核=s_shop.state=005 待审店铺数，入驻小区=s_shop_community.state=12001 待审数，店铺变更=s_shop_audit.state=001 待审数）
      todoCounts: { auditProduct: 0, importBatch: 0, openShop: 0, shopCommunity: 0, shopChange: 0 },
      menuWidth: 80,
      menuId: '',
      curMenuName: '',
      activeMenu: '',
      activeSubMenu: 'communityList',
      searchText: '',
      username: '',
      curShopName: '',
      shops: [],
      storeInfo: {
        storeTypeCd: '',
        storeId: ''
      },
      systemInfo: {
        systemSimpleTitle: '',
        companyName: '',
        logoUrl: '',
        version: '',
        qqMapKey: ''
      },
      visitedTabs: []
    }
  },
  watch: {
    $route: {
      handler(route) {
        if (!route || !route.path) {
          return
        }
        const path = route.path
        const exists = this.visitedTabs.some(t => t.path === path)
        if (!exists) {
          const info = this.getTabTitle(path, route.meta || {})
          if (info) {
            this.visitedTabs.push({ path, ...info })
          }
        }
      },
      immediate: true
    }
  },
  async created() {
    let _user = await getUserInfo()
    this.username = _user.name
    this.systemInfo.version = config.version
    this.getSystemInfo()
    this._loadStoreInfo()
    this.loadCatalogs()
    this.curShopName = getShopName()
    this.loadShop()
    initSystem()
    // 商品审核待办角标（60s 轮询）：仅运营团队有权限，商家身份轮询失败静默不展示
    this._initTodoReminder()
  },
  beforeDestroy() {
    this._destroyTodoReminder()
  },
  components: {
    moreShop,
    viewMultipleQrcode
    //   viewMenuUserList,
    //   searchCommunityDataList
  },
  methods: {
    // ========== 商品审核待办角标（参照 wyWeb 报事报修 todo 机制：60s 轮询 + 可见性刷新 + 事件刷新 + 增量标题闪烁） ==========
    _initTodoReminder() {
      this._todoPrevCounts = null
      this._todoTimer = null
      this._titleBlinkTimer = null
      this._originalTitle = document.title
      this._visibilityHandler = () => {
        if (!document.hidden) {
          this._pollAuditTodos()
        }
      }
      document.addEventListener('visibilitychange', this._visibilityHandler)
      // 审核/整批下架等业务操作完成后派发该事件，角标立即刷新，不等 60s 轮询
      this._todoChangedHandler = () => {
        this._pollAuditTodos()
      }
      window.addEventListener('mall-audit-todo-changed', this._todoChangedHandler)
      this._pollAuditTodos()
      this._todoTimer = setInterval(this._pollAuditTodos, 60000)
    },
    _destroyTodoReminder() {
      if (this._todoTimer) {
        clearInterval(this._todoTimer)
        this._todoTimer = null
      }
      if (this._visibilityHandler) {
        document.removeEventListener('visibilitychange', this._visibilityHandler)
      }
      if (this._todoChangedHandler) {
        window.removeEventListener('mall-audit-todo-changed', this._todoChangedHandler)
      }
      this._stopTitleBlink()
    },
    _pollAuditTodos: function () {
      let _that = this
      if (document.hidden) {
        return
      }
      request({
        url: '/product.queryAuditTodoCount',
        method: 'get',
        // 商家身份无运营权限时后端返回非 0 code，轮询场景静默处理，禁止全局弹错
        noGlobalError: true
      }).then(response => {
        let _body = response.data || {}
        if (_body.code !== 0 || !_body.data) {
          return
        }
        let _data = _body.data
        let _counts = {
          auditProduct: parseInt(_data.auditProductCount || '0') || 0,
          importBatch: parseInt(_data.importBatchTodoCount || '0') || 0,
          openShop: parseInt(_data.openShopCount || '0') || 0,
          shopCommunity: parseInt(_data.shopCommunityCount || '0') || 0,
          shopChange: parseInt(_data.shopChangeCount || '0') || 0
        }
        _that._updateTodoCounts(_counts)
      }).catch(() => {
        // 轮询失败静默处理（商家身份无权限、网络抖动等），不打断用户操作
      })
    },
    _updateTodoCounts(counts) {
      let _increased = false
      if (this._todoPrevCounts) {
        _increased = counts.auditProduct > this._todoPrevCounts.auditProduct
          || counts.importBatch > this._todoPrevCounts.importBatch
          || counts.openShop > this._todoPrevCounts.openShop
          || counts.shopCommunity > this._todoPrevCounts.shopCommunity
          || counts.shopChange > this._todoPrevCounts.shopChange
      }
      // 收集较上轮增加的类型，标题闪烁文案按增加项动态拼接（如「有新的开店审核、商品待审核」）
      let _increasedLabels = []
      if (this._todoPrevCounts) {
        if (counts.openShop > this._todoPrevCounts.openShop) {
          _increasedLabels.push('开店审核')
        }
        if (counts.shopCommunity > this._todoPrevCounts.shopCommunity) {
          _increasedLabels.push('入驻小区')
        }
        if (counts.shopChange > this._todoPrevCounts.shopChange) {
          _increasedLabels.push('店铺变更')
        }
        if (counts.auditProduct > this._todoPrevCounts.auditProduct
          || counts.importBatch > this._todoPrevCounts.importBatch) {
          _increasedLabels.push('商品')
        }
      }
      this._todoPrevCounts = counts
      this.todoCounts = counts
      // 计数较上轮增加时标题闪烁提醒（首轮不闪）
      if (_increased) {
        this._startTitleBlink(`【有新的${_increasedLabels.join('、')}待审核】`)
      }
    },
    // 菜单项角标：按 href 匹配挂载计数，未匹配菜单返回 0
    _todoBadgeOf(subMenu) {
      let _href = (subMenu && subMenu.href) || ''
      if (_href.indexOf('/pages/goods/adminProduct') > -1) {
        return this.todoCounts.auditProduct
      }
      if (_href.indexOf('/pages/goods/importBatchManage') > -1) {
        return this.todoCounts.importBatch
      }
      if (_href.indexOf('/pages/admin/auditOpenShop') > -1) {
        return this.todoCounts.openShop
      }
      if (_href.indexOf('/pages/admin/auditShopCommunity') > -1) {
        return this.todoCounts.shopCommunity
      }
      if (_href.indexOf('/pages/shop/shopAudit') > -1) {
        return this.todoCounts.shopChange
      }
      return 0
    },
    // 一级菜单角标：聚合其下所有二级菜单的待办计数（如「商家」=上架商品+导入管理之和）
    _todoBadgeOfParent(menu) {
      let _childs = (menu && menu.childs) || []
      let _total = 0
      for (let i = 0; i < _childs.length; i++) {
        _total += this._todoBadgeOf(_childs[i])
      }
      return _total
    },
    _startTitleBlink(blinkText) {
      this._stopTitleBlink()
      let _showTip = false
      let _that = this
      this._titleBlinkTimer = setInterval(function () {
        _showTip = !_showTip
        document.title = _showTip ? (blinkText + _that._originalTitle) : _that._originalTitle
      }, 1000)
    },
    _stopTitleBlink() {
      if (this._titleBlinkTimer) {
        clearInterval(this._titleBlinkTimer)
        this._titleBlinkTimer = null
      }
      if (this._originalTitle) {
        document.title = this._originalTitle
      }
    },
    getTabTitle(path, meta) {
      if (path === '/views/index/index' || path === '/') {
        return { title: '首页' }
      }
      const m = meta || {}
      if (m.title) return { title: m.title }
      if (m.titleKey) return { titleKey: m.titleKey }
      return null
    },
    goTab(tab) {
      if (this.$route.path === tab.path) return
      this.$router.push(tab.path).catch(err => {
        if (err && err.name !== 'NavigationDuplicated') {
          throw err
        }
      })
    },
    removeTab(tab) {
      const list = this.visitedTabs.filter(t => t.path !== tab.path)
      this.visitedTabs = list
      if (this.$route.path === tab.path) {
        const next = list.length ? list[list.length - 1] : { path: '/views/index/index' }
        this.$router.push(next.path).catch(err => {
          if (err && err.name !== 'NavigationDuplicated') {
            throw err
          }
        })
      }
    },
    closeAllTabs() {
      this.visitedTabs = []
      this.$router.push('/views/index/index').catch(err => {
        if (err && err.name !== 'NavigationDuplicated') {
          throw err
        }
      })
    },
    async getSystemInfo() {
      const { data } = await listSystemInfo({ page: 1, row: 1 });
      if (!data || data.length === 0) {
        console.warn('系统配置为空，无法获取 qqMapKey')
        return
      }
      const _systemInfo = data[0]
      this.systemInfo.systemSimpleTitle = _systemInfo.systemSimpleTitle
      this.systemInfo.companyName = _systemInfo.companyName
      this.systemInfo.logoUrl = _systemInfo.logoUrl
      this.systemInfo.qqMapKey = _systemInfo.qqMapKey

      // 把腾讯地图 Key 存入 localStorage，供地址解析等场景使用
      window.localStorage.setItem('hc_qqMapKey', this.systemInfo.qqMapKey || '')

      // 从系统配置中动态加载腾讯地图脚本，避免 key 硬编码在 index.html
      if (this.systemInfo.qqMapKey && !window.TMap) {
        const script = document.createElement('script')
        script.src = `https://map.qq.com/api/gljs?v=1.exp&key=${this.systemInfo.qqMapKey}`
        script.onerror = () => {
          console.error('腾讯地图脚本加载失败，请检查 qqMapKey 和域名白名单')
        }
        document.head.appendChild(script)
      }
    },
    async loadShop() {
      let shopId = getShopId()

      const { data } = await listMyEnteredShops({
        _uId: -1,
        page: 1,
        row: 3
      })
      this.shops = data
      if (!shopId || shopId == -1) {
        setCurrentShop(data[0])
      }
      this.curShopName = getShopName()

    },
    async _loadStoreInfo() {
      this.loading = true
      try {
        const { data } = await getStoreInfo()
        deepCopy(data[0], this.storeInfo);
      } catch (error) {
        console.error('登录失败：', error)
      } finally {
        this.loading = false
      }

    },
    async loadCatalogs() {
      this.loading = true
      try {
        const res = await _getMenuCatalog()
        if (res.code != 0) {
          return;
        }
        this.catalogs = res.data;
        if (this.catalogs && this.catalogs.length > 0) {
          this._changeMenuCatalog(this.catalogs[0])
        }
      } catch (error) {
        console.error('登录失败：', error)

      } finally {
        this.loading = false
      }
    },
    _changeMenuCatalog(_catalog, _isJump) {
      this.activeMenu = _catalog.caId;
      if (this._showModelDiv(_catalog)) {
        return;
      }
      if (_catalog.caId === '1') {
        this.$router.push('/#/pages/mall/product');
      }
      if (_catalog.url == 'IOT') {
        jumpToIot('/');
        return;
      }
      if (_catalog.url == 'MALL') {
        //获取用户名
        jumpToMall('/');
        return;
      }
      console.log(_catalog)
      if (_catalog.url != '#' && _isJump) {
        this._gotoPage(_catalog.url, _catalog.name)
        //return;
      }
      this.loadMenuTree(_catalog)
    },

    handleCommand(command) {
      if (command === 'logout') {
        // 处理退出登录

        localStorage.removeItem('token')
        localStorage.clear();
        this.$router.push('/login')
      } else if (command === 'zh' || command === 'en') {
        // 切换语言
        this.$i18n.locale = command
        localStorage.setItem('language', command)
      }
    },
    changeShop(shop) {
      if (shop == 'moreShop') {
        this.$refs.moreShop.open()
        return
      }
      setCurrentShop(shop);
      this.curShopName = getShopName()
      // 应用部署在 publicPath(/mallmanageweb/)子路径下，
      // 直接跳转 "/" 会丢失 base 路径导致页面无法加载，
      // 需使用 process.env.BASE_URL（即 publicPath）保证回到应用首页。
      window.location.href = process.env.BASE_URL
    },
    handleMenuSelect(index) {
      // 处理菜单选择
      this.$router.push({ name: index })
    },
    loadMenuTree(_catalog) {
      getMenuTree(_catalog).then(res => {
        let _menus = res.data;
        _menus.sort(function (a, b) {
          return a.seq - b.seq
        });
        if (_menus.length > 0) {
          this.menuTree = _menus;
        }

      })
    },
    switchMenu(_menu) {
      //设置菜单ID
      this.menuId = _menu.id;
      this.menuTree = this.refreshMenuActive(this.menuTree, _menu.id);
      this.subMenus = _menu.childs;
      console.log(this.subMenus)
      this.curMenuName = _menu.name;

      if (!_menu.childs || _menu.childs.length < 1) {
        return;
      }
      //选中第一个
      this._gotoPage(_menu.childs[0].href, _menu.childs[0].name);
      //vc._fix_height()
    },
    refreshMenuActive(jsonArray, _id) {
      for (let menuIndex = 0; menuIndex < jsonArray.length; menuIndex++) {
        if (jsonArray[menuIndex].childs) {
          let _childs = jsonArray[menuIndex].childs;
          _childs.sort(function (_child, _newChild) {
            return _child.seq - _newChild.seq
          });
          jsonArray[menuIndex].childs = _childs;
        }

        if (_id === jsonArray[menuIndex].id) {
          //如果当前本身是打开状态，说明 需要关闭
          jsonArray[menuIndex].active = true;
          continue;
        }
        jsonArray[menuIndex].active = false;
      }
      return jsonArray;
    },
    _setSelectedMenusChild(_href) {
      for (var menuIndex = 0; menuIndex < this.menuTree.length; menuIndex++) {
        if (this.menuTree[menuIndex].childs) {
          var _childs = this.menuTree[menuIndex].childs;
          for (var childIndex = 0; childIndex < _childs.length; childIndex++) {
            if (_href == _childs[childIndex].href) {
              this.menuTree[menuIndex].childs[childIndex].active = true;
            } else {
              this.menuTree[menuIndex].childs[childIndex].active = false;
            }
          }
        }
      }
      this.$forceUpdate();
    },
    _gotoPage(_href, _tabName) {
      console.log(_href, _tabName)
      // 子菜单默认选中
      this._setSelectedMenusChild(_href);
      if (_href.indexOf('.html') > -1) {
        window.open(_href, '_blank')
        return
      }
      if (_href.indexOf('/#/') > -1) {
        _href = _href.replace('/#/', '/')
      }

      this.$router.push(_href).catch(err => {
        // 忽略重复导航错误
        if (err.name !== 'NavigationDuplicated') {
          throw err
        }
      })
    },
    _showModelDiv: function (_catalog) {
      console.log(_catalog)
      if (_catalog.url == '?showShopQrcode') {
        let _tmpShop = getCurrentShop()
        const qrcodeList = []
        // 多店铺二维码
        qrcodeList.push({
          qrcodeName: '多店铺',
          qrCodeUrl: _tmpShop.mallIndexUrl,
          remark: '手机扫码查看多店铺'
        })
        // 单店铺二维码
        qrcodeList.push({
          qrcodeName: '单店铺',
          qrCodeUrl: _tmpShop.phoneIndexUrl,
          remark: '手机扫码查看单店铺'
        })
        // 家政店铺二维码
        qrcodeList.push({
          qrcodeName: '家政店铺',
          qrCodeUrl: _tmpShop.houseIndexUrl,
          remark: '手机扫码查看家政店铺'
        })
        // 使用多二维码组件
        this.$refs.viewMultipleQrcode.open({
          title: _tmpShop.shopName + ' - 二维码',
          qrcodes: qrcodeList
        })
        return true;
      }
      if (_catalog.url.startsWith('?')) {
        let _modelName = _catalog.url.substring(1, _catalog.url.length);
        this.$refs[_modelName].open()
        return true;
      }
      if (_catalog.url.startsWith('http')) {
        window.open(_catalog.url, '_blank')
        return true;
      }
      return false;
    },
    _toIndex() {
      // 同 changeShop：使用 publicPath 作为 base，避免丢失 /mallmanageweb/ 子路径
      location.href = process.env.BASE_URL
    }

  }
}
</script>

<style lang="scss" scoped>
.app-wrapper {
  height: 100vh;
}

.app-header {
  background-color: #1e2132;
  color: #fff;
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
}

.logo {
  width: 100px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  color: #409EFF;
  cursor: pointer;
}

.header-menu {
  border: none;
}

.header-right {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.margin-left {
  margin-left: 15px;
  color: #fff;
}

.user-info {
  color: #fff;
  cursor: pointer;
}

.app-aside {
  width: auto;
}

.menu-wrapper {
  height: 100%;
}

.el-menu-vertical {
  border: none;
}

.el-menu-vertical:not(.el-menu--collapse) {
  width: 200px;
}

.app-main {
  background-color: #f5f7fa;
  height: calc(100vh - 60px);
  padding: 15px;
}

.tabs-wrap {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  background: #fff;
  border-bottom: 1px solid #ebeef5;
  gap: 8px;
  margin: -15px -15px 15px;
}

.tabs-list {
  display: flex;
  flex-wrap: nowrap;
  gap: 4px;
  flex: 1;
  min-width: 0;
  overflow-x: auto;
}

.tabs-item {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  font-size: 13px;
  border-radius: 4px;
  cursor: pointer;
  color: #606266;
  background: #f4f4f5;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tabs-item.active {
  color: #409EFF;
  background: #ecf5ff;
  font-weight: 500;
}

.tabs-item-title {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tabs-item-close {
  margin-left: 6px;
  font-size: 12px;
  opacity: 0.7;
}

.tabs-item-close:hover {
  opacity: 1;
  color: #f56c6c;
}

.tabs-close-all {
  flex-shrink: 0;
  padding: 4px 8px;
}

:deep(.el-menu--horizontal) {
  border-bottom: none;
}

:deep(.el-menu-item) {
  height: 50px;
  line-height: 50px;
}

:deep(.el-submenu__title) {
  height: 50px;
  line-height: 50px;
  padding: 0 20px !important;
}

:deep(.el-menu--collapse) {
  width: 64px;
}

:deep(.el-menu--collapse .el-submenu__title) {
  padding: 0 !important;
  text-align: center;
}

:deep(.el-menu--collapse .el-submenu__title i) {
  margin: 0;
  font-size: 20px;
}

:deep(.el-menu--popup) {
  min-width: 200px;
  background-color: #1e2132 !important;
}

:deep(.el-menu--popup .el-menu-item) {
  background-color: #1e2132;
  color: #fff;
}

:deep(.el-menu--popup .el-menu-item:hover) {
  background-color: #2a2f45;
}

:deep(.el-menu--popup .el-menu-item.is-active) {
  color: #409EFF;
}

.vc-menu {
  border-right: 1px solid #EFEFF0;

  .vc-menu-main {
    background-color: #1F2339;
    color: #838A9B;
    text-align: center;
    width: 80px;
    font-size: 14px;
    height: calc(100vh - 60px);
    overflow-x: hidden;
    overflow-y: scroll;
    scrollbar-width: none;

    .active {
      background-color: #3E77FC;
      color: #FFFFFF;
    }
  }

  .vc-menu-main::-webkit-scrollbar {
    display: none;
  }

  ul {
    padding-inline-start: 0px;
    margin: 0;
    padding: 0;
  }

  li {
    margin: 0;
    padding: 0;
  }
}

.moreShop {
  font-weight: 600;
  color: #212529;
  font-size: 12px;
}

.vc-menu-main ul li {
  height: 45px;
  line-height: 45px;
  cursor: pointer;
  list-style-type: none;
  position: relative;
}

.vc-menu-main ul li:hover {
  background-color: #3E77FC;
  color: #FFFFFF;
}

.vc-menu-main ul li.title {
  color: #FFFFFF;
  height: 60px;
  font-size: 24px;
  line-height: 60px;
}

.vc-menu-main ul li.title a {
  text-decoration: none;
  cursor: pointer;
  color: #FFFFFF;
}

.vc-menu-sub {
  background-color: #FFFFFF;
  color: #545761;
  text-align: start;
  width: 110px;
  font-size: 14px;
  height: calc(100vh - 60px);
  overflow-x: hidden;
  overflow-y: scroll;
  scrollbar-width: none;
}

.vc-menu-sub::-webkit-scrollbar {
  display: none;
}

.vc-menu-sub .active {
  background-color: #EAF0FE;
  color: #3E77FC;
}



.vc-menu-sub ul li {
  height: 40px;
  line-height: 40px;
  padding-left: 15px;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.vc-menu-sub ul li.title {
  color: #4F525C;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  padding-left: 0px;
  border-bottom: 1px solid #F2F2F3;
  margin-bottom: 10px;
}

.vc-menu-sub ul li:hover {
  background-color: #EAF0FE;
  color: #3E77FC;
}

.vc-menu-sub ul li.sub-footer {
  background-color: #F6F6F7;
  text-align: center;
  position: fixed;
  bottom: 0;
  width: 100px;
}

/* 商品审核待办数字角标（上架商品/导入管理菜单） */
.todo-badge {
  display: inline-block;
  min-width: 18px;
  height: 18px;
  line-height: 18px;
  padding: 0 5px;
  margin-left: 6px;
  border-radius: 9px;
  background-color: #f56c6c;
  color: #fff;
  font-size: 12px;
  text-align: center;
  vertical-align: middle;
}

/* 一级菜单待办角标：一级栏宽较窄，绝对定位在菜单项右上角，不占文字空间 */
.menu-todo-badge {
  position: absolute;
  top: 4px;
  right: 4px;
  min-width: 16px;
  height: 16px;
  line-height: 16px;
  padding: 0 4px;
  border-radius: 8px;
  background-color: #f56c6c;
  color: #fff;
  font-size: 11px;
  text-align: center;
}
</style>